// extracted by mini-css-extract-plugin
module.exports = {"container":"BackButtonBar_container__2GZqV","button":"BackButtonBar_button__2TOtH","sending":"BackButtonBar_sending__3vHUY"};